import {attachModal} from '~/shared/components/ReduxModal';
import OtlPageComponent from '~/otlPage';

const OtlModal = (props: {
  closeModal?: () => void;
  args?: Record<string, () => void>;
}) => <OtlPageComponent {...props} />;

attachModal('otlModal', OtlModal);
